var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isTable
    ? _c(
        "div",
        { ref: "sortableList", staticClass: "draggable-list" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.displayDragArea
            ? _c("div", { staticClass: "drag-area", style: _vm.styleDragArea })
            : _vm._e()
        ],
        2
      )
    : _c(
        "tbody",
        { ref: "sortableList", staticClass: "draggable-list--tbody" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.displayDragArea
            ? _c("tr", { staticClass: "drag-area", style: _vm.styleDragArea }, [
                _c("td", { attrs: { colspan: 100 } }, [
                  _c("div", { staticClass: "drag-area-content" })
                ])
              ])
            : _vm._e()
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }